import { ExpandableItemsListDrawer } from '../../molecules/ExpandableBarcodeList/ExpandableBarcodeList'
import { useManualFlow, type FlowProps } from '../../../hooks'
import { useStore } from '../../../store'
import type AppStore from '../../../store/AppStore'

export function useDefaultDrawerFlow(store: AppStore): FlowProps {
  return useManualFlow(store)
}

export default function DefaultExpandableList() {
  const store = useStore()
  const flow = useDefaultDrawerFlow(store)
  return <ExpandableItemsListDrawer {...flow} />
}
